export default function getUserConfigChanges(state,newState){
  if( state.userConfig !== newState.userConfig ){
    return newState.userConfig;
  }
  return null;
}
